import * as yup from "yup";
export const postgresValidationScheme = yup.object().shape({
  host: yup.string().required("Host name is required"),
  port: yup.number().required("Port number is required"),
  database_name: yup.string().required("Database name is required"),
  username: yup.string().required("User name is required"),
  db_password: yup.string().required("Database password is required"),
  name: yup.string().required("Name is required"),
});

export const signUpValidationSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .matches(
      // eslint-disable-next-line
      /^(?=.*[!@#$%^&*()_+,\-./:;<=>?@[\\\]^_`{|}~])(?=.*[0-9]).{6}/,
      "Must contain 6 characters,one number and one special character"
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords don't match")
    .required("Please fill the confirm password"),
});

export const joinWaitListSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  name: yup.string().required("Name is required"),
  company: yup.string().required("Company is required"),
});
